'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = exports.Intent = exports.GenericIntent = undefined;

var _GenericIntent = require('./jsx/GenericIntent');

var _GenericIntent2 = _interopRequireDefault(_GenericIntent);

var _Intent = require('./jsx/Intent');

var _Intent2 = _interopRequireDefault(_Intent);

var _Content = require('./jsx/Content');

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.GenericIntent = _GenericIntent2.default;
exports.Intent = _Intent2.default;
exports.Content = _Content2.default;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/generic-intent/index.js
// module id = 1094
// module chunks = 4